<template>
<!-- eslint-disable max-len -->
  <edit-page
    :name="classTypeName"
    model-name="classObject"
    param="classId"
    page-prefix="/blade/classes"
    :create="createClass"
    :fetch="fetchClass"
    :update="updateClass"
    :remove="deleteClass"
    :stub="classToEdit"
    :validator="validator"
    :utils="utils"
    ref="edit"
    >
    <template slot-scope="{ model: classToEdit, utils: { unused }, validator }">
      <div style="margin-bottom: 15px; height: 3px; width: 100%; background-color: black;"/>

      <!-- professor/owner/admin editable -->
      <!-- <text-input
        :disabled="true"
        label
        v-model="registrationLink"
        copyable
        no-count
      >{{classTypeName}} Registration Link</text-input> -->
      <text-input v-if="!creating && !isCorpo"
        :disabled="true"
        label
        :value="studentRegistrationLink(classToEdit)"
        copyable
        no-count
      >Student Registration Link</text-input>


      <checkbox-input
        v-if="!creating && !isCorpo && !isProfessor"
        v-model="classToEdit.isCustomStudentLink"
        :disabled="!canManageGames"
      >
        Use Custom Student Link
      </checkbox-input>

      <text-input v-if="!creating && !isCorpo && !isProfessor && classToEdit.isCustomStudentLink"
        v-model.trim="classToEdit.studentLink"
        label
        required
        no-count
      >Custom Student Registration Link</text-input>

      <text-input v-if="!creating && (isCorpo || !isProfessor)"
        :disabled="true"
        label
        :value="employeeRegistrationLink(classToEdit)"
        copyable
        no-count
      >Employee Registration Link</text-input>

      <checkbox-input
        v-if="!creating && !isCorpo && !isProfessor"
        v-model="classToEdit.isCustomEmployeeLink"
        :disabled="!canManageGames"
      >
        Use Custom Employee Link
      </checkbox-input>
      <text-input v-if="!creating && !isCorpo && !isProfessor && classToEdit.isCustomEmployeeLink"
        v-model.trim="classToEdit.employeeLink"
        label
        required
        no-count
      >Custom Employee Registration Link</text-input>

      <button v-if="!creating" class="btn" @click.prevent="(ev) => generateInvite()" style="padding: 0 5px;">
        Generate Invite Link &amp; Invalidate Any Existing Invite Link
      </button>
      <checkbox-input v-model="classToEdit.requireStudentId">Require {{studentEmployeeString}} ID</checkbox-input>

      <!-- Disabled this check due to BLADE Codebase task #944 -->
      <!-- :disabled="isProfessor" -->
      <checkbox-input v-model="classToEdit.skipEmailVerification">Skip Email Verification</checkbox-input>

      <p style="margin: 0;">{{classTypeName}} Roster Upload</p>
      <p style="margin: 0; font-size: 90%;">
        (CSV with columns: first name, last name, email; each {{studentEmployeeStringLower}} will be emailed sign in instructions)
      </p>
      <input
        :disabled="creating"
        style="margin-bottom: 5px;"
        type="file"
        id="rosterFileInput"
        @change="onFileChanges"
      />
      <button
        style="margin-bottom: 15px; display: block;"
        class="btn btn-sm"
        :disabled="!uploadReady"
        @click.prevent="uploadRoster"
      >
        Upload
      </button>

      <div>
        <h5>{{classTypeName}} Roster</h5>
        <!-- {{classUsers}} -->
        <div>Total Count: {{classUsers.length}}</div>
        <b-input-group>
          <b-input-group-prepend style="margin: 5px 5px 5px 0;">
            Filter:
          </b-input-group-prepend>
          <b-input v-model="filter"/>
          <b-input-group-append>
            <checkbox-input v-if="isOwner" v-model="studentEmployeeOnly" style="margin: 0 12px;">
              Student/Employee Only
            </checkbox-input>
          </b-input-group-append>
        </b-input-group>
        <div>Filtered Count: {{formattedUsers.length}}</div>
        <b-table
          sort-by="lastName"
          :sort-desc="true"
          :items="formattedUsers"
          :fields="tableFields"
          :current-page="currentPage"
          :per-page="perPage"
          striped
          hover
          style="width: 100%; font-size: 12px;"
          @row-clicked="onRosterRowClicked"
        >
          <!-- <template #cell(paymentStatus)="data">
            <b-checkbox
              v-model="data.item.paymentStatus"
              disabled
            />
          </template> -->
        </b-table>
        <nav>
          <b-pagination
            size="sm"
            :total-rows="formattedUsers.length"
            :per-page="perPage"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
          />
        </nav>
        <b-input-group style="width: 30%; font-size: 80%;">
          <b-input-group-prepend style="margin: 8px 5px 5px 0;">
            Rows per page:
          </b-input-group-prepend>
          <b-input v-model="perPageInput" style="transform: scaleY(0.84); margin-bottom: 5px;"/>
          <b-input-group-append>
            <button class="btn" @click.prevent="updatePerPage" style="transform: scale(0.82) translate(-9%, -2%); margin-bottom: 5px;">Update</button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <b-modal ref="playthroughReportModal" title="Playthrough Report" hide-footer size="lg">
        <playthrough-report
          :workgroup="classToEdit"
          :user="selectedUser"
        ></playthrough-report>
      </b-modal>

      <div style="display: flex; flex-direction: row; margin-bottom: 15px;">
        <button class="btn" @click.prevent="loadUsageData" style="margin-right: 15px; padding: 0 5px;">
          Usage Report
        </button>
        <button class="btn" @click.prevent="loadClassData" style="margin-right: 15px; padding: 0 5px;">
          {{classTypeName}} Report
        </button>
        <button class="btn" @click.prevent="loadChallengeData" style="margin-right: 15px; padding: 0 5px;">
          Section Report
        </button>
        <button class="btn" @click.prevent="loadReasonData" style="margin-right: 15px; padding: 0 5px;">
          Reasoning Report
        </button>
        <button class="btn" @click.prevent="loadSurveyData" style="padding: 0 5px;">
          Survey Report
        </button>
      </div>

      <b-button @click.prevent="$refs.groupManagerModal.show()" style="padding: 0 5px;">
        Group Manager
      </b-button>
      <b-modal ref="groupManagerModal" title="Group Manager" hide-footer size="lg">
        <group-manager :active-class="classToEdit" :users="classUsers"></group-manager>
      </b-modal>

      <checkbox-input v-model="classToEdit.noAutoSingleplayerGroupGeneration" style="margin: 10px 0 20px 5px;">
        Disallow Automatic Singleplayer Group Generation For {{studentEmployeeStringPlural}}
      </checkbox-input>

      <number-input v-model="classToEdit.idleTimeoutSeconds">
        Idle Timeout Seconds (only active if > 0)
      </number-input>
      <div>
        <template v-if="classToEdit.idleTimeoutSeconds > 60">
          Users will be automatically loggeed out after {{classToEdit.idleTimeoutSeconds / 60}} minutes of inactivity.
        </template>
        <template v-else-if="classToEdit.idleTimeoutSeconds > 0">
          Users will be automatically loggeed out after {{classToEdit.idleTimeoutSeconds}} seconds of inactivity.
        </template>
        <template v-else>
          Idle timeout is disabled
        </template>
      </div>

      <checkbox-input v-model="classToEdit.skipGameStart">Skip Game Start</checkbox-input>

      <div style="margin-bottom: 15px; height: 3px; width: 100%; background-color: black;"/>
      <h5>{{classTypeName}} Settings</h5>

      <text-input @input="doDefaultForProf" label v-model.trim="classToEdit.className" :validator="validator.className" required max-length autofocus>
        {{classTypeName}} Name
      </text-input>

      <text-input label v-model.trim="classToEdit.courseName" :validator="validator.courseName" required max-length>
        Course Name
      </text-input>

      <text-input @input="doDefaultForProf" label v-model.trim="classToEdit.courseIdentifier" :validator="validator.courseIdentifier" max-length>
        Course Identifier
      </text-input>

      <text-input @input="doDefaultForProf" label v-model.trim="classToEdit.professorName" :validator="validator.professorName" max-length>
        {{ isInternalCorpo ? 'Professor/Instructor' : (isCorpo ? 'Instructor' : 'Professor') }}
      </text-input>

      <text-input @input="doDefaultForProf" label v-model.trim="classToEdit.universityName" :validator="validator.universityName" max-length>
        {{ isInternalCorpo ? 'University/Business Group' : (isCorpo ? 'Business Group' : 'University') }}
      </text-input>

      <text-input label v-model.trim="classToEdit.emailDomain" :validator="validator.emailDomain" max-length>
        Associated Email Domain (all {{studentEmployeeStringLowerPlural}} will be required to join the {{classTypeName}} using an email with this domain; supports wildcards)
      </text-input>

      <number-input @input="doDefaultForProf" label v-model="classToEdit.year" :validator="validator.year" max-value>
        Year
      </number-input>

      <select-input
        @input="doDefaultForProf"
        label
        v-model="classToEdit.season"
        :options="seasons"
        :validator="validator.season"
        required
      >
        Season
      </select-input>

      <text-input @input="doDefaultForProf" label v-model.trim="classToEdit.section" :validator="validator.section" max-length>
        Section
      </text-input>

      <select-input
        label
        v-model="classToEdit.game"
        :options="games"
        use="_id"
        :display="e => { return `${e.name}`; }"
        :to="(canManageGameInvites || canManageGames) ? (id) => { return `/blade/games/${id}/edit`; } : null"
        @input="(value)=>selectedGame = value"
      >
        Gamulation
      </select-input>

      <text-input label v-model.trim="classToEdit.studentReportFileName" :validator="validator.studentReportFileName" max-length>
        {{studentEmployeeString}} Report File Name
      </text-input>

      <select-input
        label
        v-model="classToEdit.choiceDisplayTypeOverride"
        :options="choiceDisplayTypeOverrideOptions"
        default-value="Do Not Force"
      >
        Choice Display Type Override
      </select-input>

      <select-input
        label
        v-model="classToEdit.reasoningInputOverride"
        :options="reasoningInputOverrideOptions"
        :validator="validator.reasoningInputOverride"
        required
      >
        Reasoning Input Override
      </select-input>

      <number-input
        label
        min-value="0"
        max-value="1000"
        v-model="classToEdit.reasoningMinimumLength"
        :validator="validator.reasoningMinimumLength"
      >
        Reasoning Minimum Length in Characters
      </number-input>

      <number-input
        label
        min-value="0"
        max-value="1000"
        v-model="classToEdit.reasoningMaximumLength"
        :validator="validator.reasoningMaximumLength"
      >
        Reasoning Maximum Length in Characters (0 or blank will default to 256)
      </number-input>

      <checkbox-input v-model="classToEdit.randomChoiceOrder">Random Choice Order for all Decisions</checkbox-input>

      <div style="margin-bottom: 15px; height: 3px; width: 100%; background-color: black;"/>
      <h5>{{studentEmployeeString}} Progress Date Lock Settings</h5>

      <text-input
        label
        v-model.trim="classToEdit.lockMessage"
        placeholder="You cannot progress further at this time. To continue, refresh after: {time}"
      >
        Display Message When Locked (use {time} to insert the unlock time)
      </text-input>

      <h6>
        Gamulation Unlock Date (can't progress past Start screen until after this date)
      </h6>

      <datetime
        v-model="classToEdit.gamulationUnlockDate"
        type="datetime"
        :id="`gdtpick`"
        use12-hour
        value-zone="UTC"
        zone="local"
      >
      </datetime>

      <h6>
        (Optionally set Gamulation Sections to be locked until a certain date. {{studentEmployeeStringPlural}} won't be able to progress until it unlocks.)
      </h6>

      <array-input
        :items="classToEdit.challengeLocks"
        :disabled="validator.challengeLocks.$invalid"
        :stub="{ challengeIndex: 0, unlockDate: new Date() }"
      >
        <h5 slot="title"><!--Section Locks--></h5>

        <div
          class="form-row"
          slot="item"
          slot-scope="{ item: cLock, index: i }"
          style="
            width: 100%;
            padding-bottom: 4px;
            margin-bottom: 12px;
            border-bottom: 1px solid grey;
          "
        >
          <div
            class="form-row"
            style="
              width: 100%;
            "
          >
            <select-input
              v-model="cLock.challengeIndex"
              :options="challengeIndexOptions"
              :display="e => {
                const suffix = (e === 0) ? 'st' : ((e === 1) ? 'nd' : ((e === 2) ? 'rd' : 'th'));
                return `${e + 1}${suffix}`;
              }"
              sort-by-key
            >
              #
            </select-input>
            <div
              style="
                margin: 8px 8px 0 8px;
              "
            >Section</div>
            <select-input
              v-model="cLock.outro"
              boolean
              :options="[false, true]"
              :defaultValue="false"
              :display="e => e ? 'end' : 'start'"
            >
              part
            </select-input>
            <div
              style="
                margin: 8px 0 0 8px;
              "
            >will unlock</div>
            <select-input
              v-model="cLock.relative"
              boolean
              :options="[false, true]"
              :defaultValue="false"
              :display="e => e ? 'after:' : 'at:'"
              style="
                margin: 0 8px;
              "
            >
              relative
            </select-input>
            <div
              v-if="cLock.relative"
              style="
                display: flex;
                flex-flow: row nowrap;
              "
            >
              <number-input
                v-model="cLock.days"
                style="
                  max-width: 100px;
                "
              >
                #
              </number-input>
              <div
                style="
                  margin: 8px 8px 0 8px;
                "
              >days after lock stops progression</div>
            </div>
            <div
              v-else
              style="
                margin-top: 4px;
              "
            >
              <!-- TODO: it would be nice to use the superior ctk picker but there are timezone issues for some reason -->
              <!-- <vue-ctk-date-time-picker
                v-model="cLock.unlockDate"
                :id="`dtpick-${i}`"
                formatted="llll Z"
              >
              </vue-ctk-date-time-picker> -->
              <datetime
                v-model="cLock.unlockDate"
                type="datetime"
                :id="`dtpick-${i}`"
                use12-hour
                value-zone="UTC"
                zone="local"
              >
              </datetime>
            </div>
            <button
              class="btn"
              style="
                margin: 0 8px;
                height: 24px;
              "
              @click.prevent="() => { classToEdit.challengeLocks.splice(i, 1); }"
            >Remove Section Lock</button>
          </div>
          <text-input
            label
            v-model.trim="cLock.lockMessageOverride"
            placeholder="Overrides: Display Message When Locked"
            style="
              width: 100%;
            "
          >
            Section Lock Message Override (use {time} to insert the unlock time)
          </text-input>
        </div>
        <span slot="button">Add Section Unlock Date</span>
      </array-input>

      <div style="margin-bottom: 15px; height: 3px; width: 100%; background-color: black;"/>
      <h5>Admin {{classTypeName}} Settings <span style="font-size: 70%;">(Professors can only view these settings)</span></h5>

      <!-- owner/admin editable -->
      <select-input
        :disabled="isProfessor"
        label
        v-model="classToEdit.environment"
        :options="environments"
        use="_id"
        :display="e => { return `${e.name}`; }"
        :to="(id) => { return !isProfessor ? `/blade/environments/${id}/edit` : null; }"
      >
        Gamulation Branding
      </select-input>

      <select-input
        :disabled="isProfessor"
        label
        v-model="classToEdit.completedGame"
        @input="() => { if (classToEdit.completedGame != null) { classToEdit.outro = null; } }"
        :options="allAssociatedGames"
        use="_id"
        :display="e => { return `${e.name}`; }"
        :to="(canManageGameInvites || canManageGames) ? (id) => { return `/blade/games/${id}/edit`; } : null"
      >
        Gamulation To Run When This Gamulation Is Completed
      </select-input>

      <!--
        currently professors can't view all outros in db and there's no separate
        endpoint for getting all the ones associated with all the games/classes they can view,
        hence using v-if rather than disabled
      -->
      <select-input
        v-if="canListOutros"
        label
        v-model="classToEdit.outro"
        @input="() => { if (classToEdit.outro != null) { classToEdit.completedGame = null; } }"
        :options="outros"
        use="_id"
        :display="e => { return `${e.name}`; }"
        :to="canManageGames ? (id) => { return `/blade/outros/${id}/edit`; } : null"
      >
        Endgame Settings (runs when Gamulation ends, repeatable, overrides Completed Gamulation)
      </select-input>

      <text-input :disabled="isProfessor" label v-model.trim="classToEdit.thumbnailTitle">Thumbnail Title</text-input>

      <text-input :disabled="isProfessor" label v-model.trim="classToEdit.classFileName">{{classTypeName}} File Name</text-input>

      <text-input :disabled="isProfessor" label v-model.trim="classToEdit.revisionText">Revision Text</text-input>

      <number-input :disabled="isProfessor" label v-model="classToEdit.price">Price</number-input>

      <!-- This specific field is for owners/admins only.  Professors shouldn't be able to create LTI keys. -->
      <class-lti-manager :classToEdit="classToEdit" />

      <array-input :v-if="canManageGameSets" :items="classToEdit.gameSets" :hide-button="classToEdit.gameSets && classToEdit.gameSets.length >= gameSetList.length">
        <h5 slot="title">Gamulation Set(s) (defines the sets of games that are visible/available to users who register with this link)</h5>

        <select-input
          slot="item"
          slot-scope="{ item: gameSet, index: i }"
          v-model="gameSet._id"
          :options="unused(gameSetList).by('_id').in(classToEdit.gameSets).by('_id').at(i)"
          use="_id"
          display="name"
          required
          autofocus
          :remove="() => { classToEdit.gameSets.splice(i, 1); }"
          :to="(id) => { return `/blade/gamesets/${id}/edit`; }"
        >
          Gamulation Set
        </select-input>
        <span slot="button">Add Gamulation Set</span>
      </array-input>

      <template v-if="canManageAllGroups">
        <h5>Copy Playthroughs to Another {{classTypeName}} (only visible to users with blade, owner, or developer roles)</h5>
        <b-checkbox v-model="userCopy.unsafe">Allow copying to any class/workgroup regardless of game (<b><i>DANGEROUS</i></b> - only use if you know for a fact that the metrics are compatible and you don't need the playthrough to be playable)</b-checkbox>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Email Filter (selects all users if blank)</b-input-group-text>
          </b-input-group-prepend>
          <b-input v-model="userCopy.emailFilter" placeholder="Email Filter (selects all users if blank)" />
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>{{classTypeName}} to Copy Into</b-input-group-text>
          </b-input-group-prepend>
          <b-select :options="classCopyOptions" v-model="userCopy.targetId"/>
        </b-input-group>
        <b-table
          v-if="userCopy.targetId"
          sort-by="lastName"
          :sort-desc="true"
          :items="userCopySelectedUsers"
          :fields="tableFields"
          striped
          hover
          style="width: 100%; font-size: 12px;"
        />
        <b-btn block @click.prevent="clickCopyUsersAndPlaythroughsToClass" :disabled="!userCopy.targetId || userCopy.isCopying">Copy</b-btn>
      </template>

      <template v-if="(canManageSomeDashboardData) && dashboardsEnabled">
        <template v-if="!creating">
          <!-- <array-input
            v-if="validDashboardProfiles.length > 0"
            :items="classToEdit.dashboardProfiles"
            :hide-button="classToEdit.dashboardProfiles.length === validDashboardProfiles.length"
            :validator="validator.dashboardProfiles"
          >
            <h5 slot="title">Dashboard Profiles</h5>

            <div class="form-row" slot="item" slot-scope="{ item: profile, index: i }">
              <select-input
                v-model="profile._id"
                :validator="validator.dashboardProfiles.$each[i]._id"
                :options="unused(validDashboardProfiles).by('_id').in(classToEdit.dashboardProfiles).by('_id').at(i)"
                use="_id"
                display="name"
                required
                autofocus
                :remove="() => { classToEdit.dashboardProfiles.splice(i, 1); }"
                :to="(id) => { return `/blade/dashboards/profiles/${id}/edit`; }"
              >
                Dashboard Profile
              </select-input>
            </div>
            <span slot="button">Add Dashboard Profile</span>
          </array-input>
          <div v-else>
            <h5 slot="title">Dashboard Profiles</h5>
            <b-alert show variant="warning">No compatible dashboard profiles found</b-alert>
          </div> -->
          <collapsible-section
            name="Dashboard Settings"
            id="DS"
            bold
            :buttonStyle="{
              'font-size': '140%'
            }"
          >
            <template v-if="canManageDashboards">
              <h5>Dashboard Profiles</h5>
              <!-- <div>
                <div>DEBUG</div>
                {{classToEdit.dashboardProfiles}}
                <div>/DEBUG</div>
              </div> -->
              <checkbox-input
                v-model="classToEdit.displayInDashboardsByDefault"
              >
                Display In All Gamulation Dashboards By Default
              </checkbox-input>
              <i>Note: Setting a default dashboard enables the "dashboard" navbar link for this {{classTypeName}}</i>
              <div v-for="(profile, idx) of validDashboardProfiles" class="dashboard-profile-root" :key="`profile-${idx}`">
                <div style="display: flex; flex-direction: row; align-items: center;">
                  <div>{{profile.name}}</div>
                  <div style="margin-left: 40px;">
                    <checkbox-input
                      @input="(value)=>onDashboardProfileEnableChanged(classToEdit, profile, value)"
                      :value="classToEdit.dashboardProfiles.find(dprof=>dprof._id === profile._id)"
                    >
                      {{classToEdit.displayInDashboardsByDefault ? 'Disabled' : 'Enabled' }}
                    </checkbox-input>
                  </div>
                  <div style="margin-left: 40px;">
                    <checkbox-input
                      @input="(value)=>onDashboardProfileDefaultChanged(classToEdit, profile, value)"
                      :value="classToEdit.defaultDashboardId === profile.dashboard._id"
                    >
                      Default Dashboard
                    </checkbox-input>
                  </div>
                </div>
              </div>
            </template>
            <hr/>
            <array-input
              :items="classToEdit.dashboardUserExclusionList"
              :hide-button="classToEdit.dashboardUserExclusionList.length === classUsers.length"
              v-if="canManageDashboardUserExclusionList"
            >
              <h5 slot="title">Users to exclude from dashboard</h5>

              <select-input
                slot="item"
                slot-scope="{ item: user, index: i }"
                v-model="user._id"
                :options="unused(classUsersSortedByEmail).by('_id').in(classToEdit.dashboardUserExclusionList).by('_id').at(i)"
                use="_id"
                display="email"
                required
                autofocus
                :remove="() => { classToEdit.dashboardUserExclusionList.splice(i, 1); }"
                :to="(id) => { return `/blade/users/${id}/edit`; }"
              >
                User
              </select-input>
            </array-input>
          </collapsible-section>
        </template>
        <template v-else>
          <b-alert show variant="warning">
            Dashboard setup is only available after {{classTypeName}} creation.
          </b-alert>
        </template>
      </template>
      <div style="margin-bottom: 15px; height: 3px; width: 100%; background-color: black;"/>
    </template>
  </edit-page>
</template>

<script>
import { required, maxLength, maxValue, minValue } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import FileSaver from 'file-saver';

// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import { Datetime } from 'vue-datetime';

import { unused } from '../../../utils/utils';
import EditPage from '../../ui/pages/EditPage';

import GroupManager from './components/GroupManager';
import ClassLtiManager from './components/ClassLTIManager';

import PlaythroughReport from './PlaythroughReport';

import SelectInput from '../../ui/inputs/SelectInput';
import ArrayInput from '../../ui/inputs/ArrayInput';
import TextInput from '../../ui/inputs/TextInput';
import CollapsibleSection from '../../ui/inputs/CollapsibleSection';
import NumberInput from '../../ui/inputs/NumberInput';
import CheckboxInput from '../../ui/inputs/CheckboxInput';

import { isTransactionStatusPaid } from '../../../utils/braintree-util';

export default {
  components: {
    ClassLtiManager,
    EditPage,
    SelectInput,
    ArrayInput,
    TextInput,
    CollapsibleSection,
    CheckboxInput,
    NumberInput,
    GroupManager,
    // VueCtkDateTimePicker,
    Datetime,
    PlaythroughReport,
  },
  data() {
    return {
      userCopy: {
        unsafe: false,
        targetId: null,
        classList: [],
        emailFilter: '',
        isCopying: false
      },

      gameSetList: [],
      utils: {
        unused
      },
      classToEdit: {
        // metadata
        _id: '',
        // professor editable
        className: '',
        courseName: '',
        courseIdentifier: '',
        professorName: '',
        universityName: '',
        emailDomain: '',
        year: 2021,
        season: 'Fall',
        section: '',
        game: null,
        studentReportFileName: '',
        choiceDisplayTypeOverride: 'Do Not Force',
        reasoningInputOverride: 'Do Not Force',
        reasoningMinimumLength: 0,
        reasoningMaximumLength: 0,
        randomChoiceOrder: false,
        noAutoSingleplayerGroupGeneration: false,
        idleTimeoutSeconds: 0,
        skipGameStart: false,
        requireStudentId: false,
        skipEmailVerification: false,
        // admin/owner editable
        environment: null,
        completedGame: null,
        outro: null,
        thumbnailTitle: '',
        classFileName: '',
        revisionText: '',
        ltiNavButtonText: '',
        ltiConsumerKey: undefined,
        ltiSharedSecret: undefined,
        price: 24.5,
        defaultDashboard: null,
        gamulationUnlockDate: new Date(0), // default Jan 1 1970
        challengeLocks: [],
        dashboardProfiles: [],
        dashboardUserExclusionList: [],
        displayInDashboardsByDefault: false
      },
      choiceDisplayTypeOverrideOptions: [],
      reasoningInputOverrideOptions: [],
      seasons: [],
      validator: {
        className: { required, maxLength: maxLength(300) },
        courseName: { required, maxLength: maxLength(300) },
        courseIdentifier: { maxLength: maxLength(300) },
        professorName: { maxLength: maxLength(100) },
        universityName: { maxLength: maxLength(300) },
        emailDomain: { maxLength: maxLength(300) },
        year: { maxValue: maxValue(9999) },
        section: { maxLength: maxLength(300) },
        studentReportFileName: { maxLength: maxLength(50) },
        reasoningInputOverride: { required },
        reasoningMinimumLength: { minValue: minValue(0), maxValue: maxValue(1000) },
        reasoningMaximumLength: { minValue: minValue(0), maxValue: maxValue(1000) },
        season: { required },
        challengeLocks: {
          $each: {
            challengeIndex: { required },
            unlockDate: { required }
          }
        },
        dashboardProfiles: {
          // TODO: Set the following up later
          // ensureSingleDashboardMapping: (value) => {
          //   if (!value) return false;
          //   for (let i = 0; i < value.length; i++) {
          //     for (let ii = i + 1; ii < value.length; ii++) {
          //       if (value[i]._id === value[ii]._id) return false;
          //     }
          //   }
          //   return true;
          // },
          $each: {
            _id: { required }
          }
        },
      },
      games: [],
      allAssociatedGames: [],
      outros: [],
      environments: [],
      classUsers: [],
      currentPage: 1,
      perPage: 25,
      perPageInput: 25,
      filter: '',
      rosterFile: null,
      uploadingRoster: false,
      studentEmployeeOnly: false,
      defaultChallengeIndexOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],

      selectedUser: null,

      selectedGame: null,
      dashboardProfiles: []
    };
  },
  computed: {
    ...mapGetters([
      'dashboardsEnabled',
      'isProfessor',
      'isOwner',
      'isOwnerOrAdmin',
      'isCorpo',
      'isInternalCorpo',
      'classTypeName',
      'classTypeNameLower',
      'canManageAllGroups',
      'canManageGames',
      'canManageGameSets',
      'canManageDashboards',
      'canManageDashboardUserExclusionList',
      'canManageGameInvites',
      'canListOutros',
      'canSelectGame'
    ]),
    canManageSomeDashboardData() {
      return this.canManageDashboards || this.canManageDashboardUserExclusionList;
    },
    classUsersSortedByEmail() {
      const sorted = Array.from(this.classUsers);
      sorted.sort((a, b) => a.email.localeCompare(b.email));
      return sorted;
    },
    userCopySelectedUsers() {
      if (!this.userCopy.targetId) return [];

      const filter = (this.userCopy.emailFilter || '').trim().toLowerCase();
      if (filter === '') return this.formattedUsers;
      return this.formattedUsers.filter(user => user.email.toLowerCase().includes(this.userCopy.emailFilter));
    },
    classCopyOptions() {
      if (!this.userCopy.classList) return [];

      const thisClassId = this.$route.params.classId;
      let foundNonCurrent = false;
      // eslint-disable-next-line no-shadow
      const intermediate = [{
        value: null,
        text: 'Select a Class/Workgroup to copy this Playthrough to',
        disabled: true
      }].concat(this.userCopy.classList
        .filter(course => this.userCopy.unsafe || course.game === this.selectedGame)
        .map((course) => {
          if (course._id === thisClassId) {
            return {
              value: null,
              text: `${course.className || course.courseName} (current)`,
              disabled: true
            };
          }
          foundNonCurrent = true;
          return ({
            value: course._id,
            text: course.className || course.courseName
          });
        }));

      if (!foundNonCurrent) {
        return [{
          value: null,
          text: 'No valid Classes/Workgroups to copy this Playthrough to.  Make sure that another class/workgroup exists for this game.',
          disabled: true
        }];
      }
      return intermediate;
    },
    creating() {
      return !(this.$route.params.classId);
    },
    validDashboardProfiles() {
      if (!this.selectedGame) return [];
      const selectedGame = this.games.find(game => game._id === this.selectedGame);

      if (!selectedGame || !selectedGame.dashboardProfiles) return [];
      const res = this.dashboardProfiles.filter(
        profile => selectedGame.dashboardProfiles.find(gameProfile => gameProfile._id === profile._id)
      );
      console.log({ res });
      return res;
    },
    registrationLink() {
      return this.creating
        ? `Registration Link Will Generate Here After ${this.classTypeName} Is Created.`
        : `${window.location.origin}/signup/class/${this.$route.params.classId}`;
    },
    studentEmployeeString() {
      return this.isInternalCorpo ? 'Student/Employee' : (this.isCorpo ? 'Employee' : 'Student');
    },
    studentEmployeeStringLower() {
      return this.isInternalCorpo ? 'student/employee' : (this.isCorpo ? 'employee' : 'student');
    },
    studentEmployeeStringPlural() {
      return this.isInternalCorpo ? 'Students/Employees' : (this.isCorpo ? 'Employees' : 'Students');
    },
    studentEmployeeStringLowerPlural() {
      return this.isInternalCorpo ? 'students/employees' : (this.isCorpo ? 'employees' : 'students');
    },
    uploadReady() {
      return !this.creating && !(this.uploadingRoster) && this.rosterFile != null;
    },
    challengeIndexOptions() {
      // TODO: compute the max from the Class's Game?
      return this.defaultChallengeIndexOptions;
    },
    tableFields() {
      const fields = [
        { key: 'lastName', sortable: true },
        { key: 'firstName', sortable: true },
        { key: 'email', sortable: true },
        { key: 'status', sortable: true },
        {
          key: 'lastSignedIn',
          sortable: true,
          sortByFormatted: false,
          formatter: (value, key, item) => this.computeCreationDateString(item.lastSignedIn)
        },
        { key: 'paymentStatus', sortable: true },
      ];
      return fields;
    },
    formattedUsers() {
      let intermediate =
        (this.studentEmployeeOnly)
          ? this.classUsers.filter(u => u.roles.some(({ _id }) => ['student', 'employee'].includes(_id)))
          : this.classUsers;
      const trimmed = this.filter.trim().toLowerCase();
      if (trimmed !== '') {
        intermediate = intermediate.filter(a =>
          a.lastName.toLowerCase().includes(trimmed)
          || a.email.toLowerCase().includes(trimmed)
          || a.firstName.toLowerCase().includes(trimmed)
        );
      }
      // compute payment status
      intermediate.forEach((a) => {
        a.paymentStatus = 'unpaid';
        if (this.$refs.edit && (parseFloat(this.$refs.edit.model.price) === 0)) {
          a.paymentStatus = 'paid';
          return;
        }
        if (a.classTransactions != null) {
          const transactions = a.classTransactions.filter(t => `${t._id}` === this.$route.params.classId);
          let didPay = false;

          // eslint-disable-next-line no-restricted-syntax
          for (const transaction of transactions) {
            didPay = didPay ||
              (transaction && transaction.status && isTransactionStatusPaid(transaction.status));
          }
          a.paymentStatus = didPay ? 'paid' : 'unpaid';
        }
      });

      return intermediate;
    }
  },
  methods: {
    ...mapActions([
      'getDashboardProfiles',
      'getClass',
      'getClasses',
      'getAssignedGames',
      'getAllAssociatedGames',
      'getClassEnums',
      'createClass',
      'copyUsersAndPlaythroughsToClass',
      'updateClass',
      'deleteClass',
      'getGames',
      'getGameSets',
      'getEnvironments',
      'getOutros',
      'generateClassInvite',
      'uploadClassRoster',
      'flashSuccess',
      'flashPrimary',
      'flashDanger',
      'getClassUsers',
      'getUsageData',
      'getReasonData'
    ]),
    ...mapMutations([
      'setTableData',
      'setExportFileName',
      'setDefaultSortFunction',
      'setRootLoadingMessage'
    ]),
    async fetchClass(param) {
      const res = await this.getClass(param);
      if (res.classObject) {
        this.selectedGame = res.classObject.game;
      }
      return res;
    },
    async generateInvite() {
      await this.generateClassInvite({ _id: this.$route.params.classId });
      this.$router.go(0); // refresh
    },
    studentRegistrationLink(classObj) {
      return this.creating
        ? `Registration Link Will Generate Here After ${this.classTypeName} Is Created.`
        : `${window.location.origin}/signup/student/${classObj.studentLink ? classObj.studentLink : this.$route.params.classId}`;
    },
    employeeRegistrationLink(classObj) {
      return this.creating
        ? `Registration Link Will Generate Here After ${this.classTypeName} Is Created.`
        : `${window.location.origin}/signup/employee/${classObj.employeeLink ? classObj.employeeLink : this.$route.params.classId}`;
    },
    onRosterRowClicked(item, /* index, ev */) {
      // console.log(item);
      // console.log(index);
      // console.log(ev);
      this.selectedUser = item;
      this.$refs.playthroughReportModal.show();
    },
    onDashboardProfileEnableChanged(classToEdit, profile, value) {
      if (value) {
        const idx = classToEdit.dashboardProfiles.findIndex(dprof => dprof._id === profile._id);
        if (idx >= 0) return;

        classToEdit.dashboardProfiles.push({ _id: profile._id });
      } else {
        const idx = classToEdit.dashboardProfiles.findIndex(dprof => dprof._id === profile._id);
        if (idx < 0) return;

        classToEdit.dashboardProfiles.splice(idx, 1);
      }
    },

    onDashboardProfileDefaultChanged(classToEdit, profile, value) {
      if (value) {
        classToEdit.defaultDashboardId = profile.dashboard._id;
      } else {
        classToEdit.defaultDashboardId = null;
      }
    },

    doDefaultForProf() {
      if (this.creating || !this.classToEdit.classFileName) {
        this.classToEdit.classFileName = `${
          this.classToEdit.courseIdentifier} ${
          this.classToEdit.year} ${
          this.classToEdit.season} ${
          this.classToEdit.section}`;
      }
      if (this.creating || !this.classToEdit.revisionText) {
        this.classToEdit.revisionText = `${
          this.classToEdit.professorName} - ${
          this.classToEdit.className}`;
      }
      if (this.creating || this.classToEdit.price == null) {
        this.classToEdit.price = 24.5;
      }
    },
    onFileChanges() {
      const fileInput = document.getElementById('rosterFileInput');
      this.rosterFile = fileInput.files[0];
    },
    uploadRoster() {
      if (this.uploadReady) {
        this.uploadingRoster = true;
        const reader = new FileReader();
        reader.onload = async(evt) => {
          console.log(evt.target.result);
          const outputCsvString = await this.uploadClassRoster({
            classId: this.$route.params.classId,
            csvString: evt.target.result
          });
          const blob = new Blob([outputCsvString], { type: 'text/csv;charset=utf-8' });
          FileSaver.saveAs(blob, 'Roster.csv');
          if (!(this.creating)) {
            this.classUsers = await this.getClassUsers({ classId: this.$route.params.classId });
          }
        };
        reader.readAsText(this.rosterFile);
        this.uploadingRoster = false;
      }
    },
    computeCreationDateString(date) {
      if (!date) {
        return '';
      }
      return new Date(date).toLocaleString();
    },
    updatePerPage() {
      this.perPage = this.perPageInput;
    },
    async loadUsageData() {
      const defaultDateOptions = Intl.DateTimeFormat().resolvedOptions();

      // this.flashPrimary({ message: 'Please wait. Usage data loading...' });
      this.setRootLoadingMessage('Please wait. Usage data loading...');

      const dataObject = await this.getUsageData({
        includeEmail: true,
        includeName: true,
        includeStudentId: true,
        includeLastSignedInTimestamp: true,
        includeActivity: true,
        includeIndividualDecisionProgress: true,
        includeTeamDecisionProgress: true,
        includeLastQuestionAnsweredTimestamp: true,
        includeCompletedTimestamp: true,
        includeCash: false,
        metricsToInclude: [],
        gamesToInclude: [],
        includeHelpClicks: false,
        timeZone: defaultDateOptions.timeZone,
        locale: defaultDateOptions.locale,
        classesToInclude: [{ _id: this.$route.params.classId }],
        includeAllUsers: false,
        includeAllGameMetrics: false,
        includeDuration: true,
      });

      this.setRootLoadingMessage('');
      this.setExportFileName('usage.csv');
      this.setTableData(dataObject);
      this.setDefaultSortFunction((a, b) => {
        try {
          return a[0].localeCompare(b[0]);
        } catch (_) {
          return 0;
        }
      });

      this.$router.push('/blade/dataTable');
    },
    async loadClassData() {
      const defaultDateOptions = Intl.DateTimeFormat().resolvedOptions();

      // eslint-disable-next-line max-len
      // this.flashPrimary({ message: `Please wait. ${this.classTypeName} data loading...` });
      this.setRootLoadingMessage(`Please wait. ${this.classTypeName} data loading...`);

      const dataObject = await this.getUsageData({
        includeEmail: true,
        includeName: true,
        includeStudentId: true,
        includeLastSignedInTimestamp: false,
        includeActivity: true,
        includeIndividualDecisionProgress: false,
        includeTeamDecisionProgress: false,
        includeLastQuestionAnsweredTimestamp: false,
        includeCompletedTimestamp: false,
        includeCash: undefined, // use Game's show cash in reports setting
        metricsToInclude: [],
        gamesToInclude: [],
        includeHelpClicks: false,
        timeZone: defaultDateOptions.timeZone,
        locale: defaultDateOptions.locale,
        classesToInclude: [{ _id: this.$route.params.classId }],
        includeAllUsers: false,
        includeAllGameMetrics: true
      });

      this.setRootLoadingMessage('');
      this.setExportFileName(`${this.classTypeNameLower}report.csv`);
      this.setTableData(dataObject);
      this.setDefaultSortFunction((a, b) => {
        try {
          return a[0].localeCompare(b[0]);
        } catch (_) {
          return 0;
        }
      });

      this.$router.push('/blade/dataTable');
    },
    async loadChallengeData() {
      const defaultDateOptions = Intl.DateTimeFormat().resolvedOptions();

      // eslint-disable-next-line max-len
      // this.flashPrimary({ message: `Please wait. ${this.classTypeName} data loading...` });
      this.setRootLoadingMessage('Please wait. Section data loading...');

      const dataObject = await this.getUsageData({
        includeEmail: true,
        includeName: true,
        includeStudentId: true,
        includeLastSignedInTimestamp: false,
        includeActivity: true,
        includeIndividualDecisionProgress: true,
        includeTeamDecisionProgress: true,
        includeLastQuestionAnsweredTimestamp: true,
        includeCompletedTimestamp: false,
        includeCash: undefined, // use Game's show cash in reports setting
        metricsToInclude: [],
        gamesToInclude: [],
        includeHelpClicks: false,
        timeZone: defaultDateOptions.timeZone,
        locale: defaultDateOptions.locale,
        classesToInclude: [{ _id: this.$route.params.classId }],
        includeAllUsers: false,
        includeAllGameMetrics: true,
        perChallengeTeamMetrics: true,
        includePercentIndividualMetrics: true,
      });

      this.setRootLoadingMessage('');
      this.setExportFileName(`${this.classTypeNameLower}report.csv`);
      this.setTableData(dataObject);
      this.setDefaultSortFunction((a, b) => {
        try {
          return a[0].localeCompare(b[0]);
        } catch (_) {
          return 0;
        }
      });

      this.$router.push('/blade/dataTable');
    },
    async loadReasonData() {
      // this.flashPrimary({ message: 'Please wait. Reasoning data loading...' });
      this.setRootLoadingMessage('Please wait. Reasoning data loading...');

      const dataObject = await this.getReasonData({
        includeEmail: false,
        includeName: true,
        gamesToInclude: [],
        classesToInclude: [{ _id: this.$route.params.classId }],
        includeAllUsers: false,
        onlyFeedback: false,
        includeCompletedGame: false,
        excludeFeedback: true
      });

      this.setRootLoadingMessage('');
      this.setExportFileName('reasoning.csv');
      this.setTableData(dataObject);
      this.setDefaultSortFunction((a, b) => {
        try {
          return a[0].localeCompare(b[0]);
        } catch (_) {
          return 0;
        }
      });

      this.$router.push('/blade/dataTable');
    },
    async loadSurveyData() {
      // this.flashPrimary({ message: 'Please wait. Survey data loading...' });
      this.setRootLoadingMessage('Please wait. Survey data loading...');

      const dataObject = await this.getReasonData({
        includeEmail: false,
        includeName: false,
        gamesToInclude: [],
        classesToInclude: [{ _id: this.$route.params.classId }],
        includeAllUsers: false,
        onlyFeedback: true,
        includeCompletedGame: true,
        excludeFeedback: false
      });

      this.setRootLoadingMessage('');
      this.setExportFileName('surveydata.csv');
      this.setTableData(dataObject);
      this.setDefaultSortFunction((a, b) => {
        try {
          let res = a[2].localeCompare(b[2]); // decision (A-Z)
          if (res === 0) {
            res = b[3].localeCompare(a[3]); // choice (Z-A)
            if (res === 0) {
              return a[0].localeCompare(b[0]); // user (A-Z)
            }
            return res;
          }
          return res;
        } catch (_) {
          return 0;
        }
      });

      this.$router.push('/blade/dataTable');
    },

    async clickCopyUsersAndPlaythroughsToClass() {
      try {
        this.userCopy.isCopying = true;

        const sourceClassId = this.$route.params.classId;
        const destClassId = this.userCopy.targetId;

        if (!sourceClassId || !destClassId) {
          this.flashDanger({ message: 'Please select a destination class/workgroup' });
          return;
        }

        const sourceClass = await this.getClass({ classId: sourceClassId });
        const destClass = await this.getClass({ classId: destClassId });

        if (!sourceClass || !destClass) {
          this.flashDanger({ message: 'Please select a valid destination class/workgroup' });
          return;
        }

        const unsafe = this.userCopy.unsafe;
        if (!unsafe) {
          if (sourceClass.game !== destClass.game) {
            this.flashDanger({ message: 'Source and destination classes/workgroups must have the same game' });
            return;
          }
        }

        const emailFilter = (this.userCopy.emailFilter || '').trim().toLowerCase();

        try {
          const res = await this.copyUsersAndPlaythroughsToClass({
            sourceClassId,
            destClassId,
            unsafe,
            emailFilter
          });

          console.log(res);
          this.flashSuccess({ message: 'Successfully copied users and playthroughs' });
        } catch (err) {
          if (err.response && err.response.data) {
            if (err.response.data.message) {
              this.flashDanger({ message: `Failed to copy users: ${err.response.data.message}` });
            } else {
              this.flashDanger({ message: `Failed to copy users: ${err.response.data}` });
            }
          } else {
            this.flashDanger({ message: 'Failed to copy users: Unknown error' });
          }
        }
      } finally {
        this.userCopy.isCopying = false;
      }
    }
  },
  async created() {
    try {
      this.games =
        ((this.canSelectGame) ? (await this.getGames()) : (await this.getAssignedGames()));

      if (this.canManageGameSets) {
        this.gameSetList = await this.getGameSets();
      }

      this.allAssociatedGames =
        ((this.canSelectGame) ? this.games : (await this.getAllAssociatedGames()));
      this.environments = await this.getEnvironments();
      if (this.canListOutros) {
        this.outros = await this.getOutros();
      }
      if (!(this.creating)) {
        this.classUsers = await this.getClassUsers({ classId: this.$route.params.classId });
      }
    } catch (_) {
      const message = 'Error fetching gamulations and gamulation brandings, please try again';
      this.flashDanger({ message });
    }
  },
  async mounted() {
    const {
      choiceDisplayTypeOverrideOptions,
      reasoningInputOverrideOptions,
      seasons
    } = await this.getClassEnums();
    this.userCopy.classList = await this.getClasses();
    this.choiceDisplayTypeOverrideOptions = choiceDisplayTypeOverrideOptions;
    this.reasoningInputOverrideOptions = reasoningInputOverrideOptions;
    this.seasons = seasons;
    if (!this.creating && this.dashboardsEnabled && this.canManageDashboards) {
      this.dashboardProfiles = await this.getDashboardProfiles();
    }
  }
};
</script>

<style lang="scss" scoped>
.form-image-background + span {
  display: block;
  margin: -10px 0 10px 10px;
}
.form-image-background {
  background-color: rgba(0, 0, 0, 0);
}
.dashboard-profile-root {
  padding: 10px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/ClassEdit.vue